import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useEffect } from "react";
import { LogOut, Music, FileText, Inbox, ExternalLink, MessageCircle, Film } from "lucide-react";

export default function AdminLayout() {
  const { user, checking, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!checking && !user) navigate("/admin/login", { replace: true });
  }, [checking, user, navigate]);

  if (checking || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center admin-body">
        <p className="text-[var(--text-secondary)]">Loading...</p>
      </div>
    );
  }

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-md text-sm transition-colors ${
      isActive
        ? "bg-[var(--accent)] text-white"
        : "text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)] hover:text-[var(--text-primary)]"
    }`;

  return (
    <div className="min-h-screen admin-body flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-[var(--border)] bg-white flex flex-col">
        <div className="px-6 py-6 border-b border-[var(--border)]">
          <p className="font-display text-2xl">Studio</p>
          <p className="text-xs text-[var(--text-secondary)] mt-1">{user.email}</p>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-instruments">
            <Music size={16} /> Instruments
          </NavLink>
          <NavLink to="/admin/content" className={linkCls} data-testid="admin-nav-content">
            <FileText size={16} /> Site content
          </NavLink>
          <NavLink to="/admin/inquiries" className={linkCls} data-testid="admin-nav-inquiries">
            <Inbox size={16} /> Inquiries
          </NavLink>
          <NavLink to="/admin/stories" className={linkCls} data-testid="admin-nav-stories">
            <MessageCircle size={16} /> Stories
          </NavLink>
          <NavLink to="/admin/media" className={linkCls} data-testid="admin-nav-media">
            <Film size={16} /> Connect videos
          </NavLink>
        </nav>
        <div className="p-3 border-t border-[var(--border)] space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-3 rounded-md text-sm text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]" data-testid="admin-view-site">
            <ExternalLink size={16} /> View site
          </Link>
          <button onClick={logout} className="flex items-center gap-3 px-4 py-3 rounded-md text-sm text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)] w-full" data-testid="admin-logout">
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 px-8 py-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
